import { render, staticRenderFns } from "./ProductsListItem.vue?vue&type=template&id=7df10906&"
import script from "./ProductsListItem.vue?vue&type=script&lang=js&"
export * from "./ProductsListItem.vue?vue&type=script&lang=js&"
import style0 from "./ProductsListItem.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports